/**
 * Contact Categories.
 *
 * @format
 */

export const contactCategoriesList = [
  { name: 'Events', value: 'Events' },
  { name: 'Human Resources', value: 'Human Resources' },
  { name: 'Media Relations', value: 'Media Relations' },
  { name: 'Products & Services', value: 'Products & Services' },
  { name: 'Training & Education', value: 'Training & Education' },
  { name: 'Other', value: 'Other' },
];
